import React, { Component, Fragment } from 'react'
import { ApiHelper } from '../../helpers/ApiHelper';
import { css, StyleSheet } from 'aphrodite';
import { AppStyles, AppTheme } from '../../../styles/AppTheme';
import { SEStyles } from './SEStyles';
import { Grid, Card, CardContent, CardActionArea, Tooltip, Paper, Button } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { Helper } from '../../helpers/Helper';
import { AppHelper } from '../../../helpers/AppHelper';
import { TableComponent } from '../TableComponent';

export class SubEntityList extends Component {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <div className={css(SEStyles.container)}>
        <div className={css(SEStyles.content)}>
          <div className={css(SEStyles.heading)}>
            <h2 className={css(SEStyles.stepFormTitle)}>{this.props.title}</h2>
            {<Button className={css(SEStyles.editButton)} onClick={() => this.props.openModalForAdd()}>
              Add
            </Button>}
          </div>
          <TableComponent
            compact
            tableHeadersMap={this.props.tableHeadersMap}
            items={this.props.items}
            onActions={this.onActions.bind(this)}
          />
        </div>
      </div>
    )
  }

  onActions = (current) => {
    const actions = []
    actions.push(
      <Tooltip title='Edit' placement='top-start' key={current.id + 'editTT'}>
        <span className={css(AppStyles.entityTableLinkIcon)}>
          <i className='material-icons' onClick={() => this.props.openModalForEdit(current)}>edit</i>
        </span>
      </Tooltip>
    )
    actions.push(
      <Tooltip title='Delete' placement='top-start' key={current.id + 'deleteTT'}>
        <span className={css(AppStyles.entityTableLinkIcon)}>
          <i className='material-icons' onClick={() => this.props.openModalForDelete(current)}>delete</i>
        </span>
      </Tooltip>
    )
    return actions
  }
}

const Styles = StyleSheet.create({
})


// WEBPACK FOOTER //
// ./src/common/components/SubEntity/SubEntityList.js